module.exports = __webpack_public_path__ + "static/img/co8.e9880d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co8.jpg
// module id = Bjc+
// module chunks = 11